export { default as DiseaseEncyclopediaTotalView } from './ui/DiseaseEncyclopediaTotalView';
export { default as useDiseaseEncyclopediaTotalViewModel } from './hooks/useDiseaseEncyclopediaTotalViewModel';
